import { Button, withStyles, WithStyles, withTheme, WithTheme } from '@material-ui/core'; // Should have Button
import * as React from 'react';

import amazonLogo from '../assets/images/amazonAppStoreLogo.png';
import appleLogo from '../assets/images/appleAppStoreLogo.png';
import garbingeLogo from '../assets/images/garbingeLogo.png';
import garbingeTitle from '../assets/images/gbTitle1.png';
import itchIoLogo from '../assets/images/logo_transparent.png';
import riskSystemLogo from '../assets/images/riskSystemLogo.png';
import steamLogo from '../assets/images/steamLogo.png';

import garbingeSizzle from '../assets/video/garbingeFinalTrailer.mp4';
import riskSystemSizzle from '../assets/video/riskSystemSizzle2.mp4';
import { HeroStoryPanning } from './HeroStoryPanning';
const styles = {

}

interface IComponentState {
	scrollPosition: number;
}

type Props = WithStyles & WithTheme;

export class Home extends React.Component<Props, IComponentState> {
	constructor(props: Props) {
		super(props);
		this.state = {
			scrollPosition: 0
		};
	}

	public render() {
		const { classes } = this.props;
		return (
			<div style={{ backgroundColor: '#544a4c' }}>
				<HeroStoryPanning classes={classes} name={'Risk System Hero'} innerContent={this.getRiskSystemCopy()} backgroundImage={riskSystemLogo} backgroundVideo={riskSystemSizzle} />
				<HeroStoryPanning classes={classes} name={'Garbinge! Hero'} innerContent={this.getGarbingeCopy()} backgroundImage={garbingeLogo} titleImage={garbingeTitle} backgroundVideo={garbingeSizzle} hidden={true} />
			</div>
		);
	}

	private getRiskSystemCopy() {
		return (
			<div>
				<div className="youtubeContainer">
					<iframe className="youtubeVideo" src="https://www.youtube.com/embed/77ns1S_qV_4" frameBorder="0" allowFullScreen={true} />
				</div>
				<p>In the distant future, humanity has discovered a method to replicate matter through the use of a Dimensional Gate. Industry is revolutionized overnight and a short period of chaos gives way to all warring factions uniting under a common banner.<br /><br />A few years pass and the peace brought about by Gate Technology crumbles once a new threat appears; a race of energy parasites that have crossed through the Dimensional Gate by mimicking the very materials humanity had believed they were replicating. Mankind is quickly overtaken as their technology is turned against them and the energy emitted by the parasites begins to take control of those exposed.<br /><br />In an act of desperation, the experimental RSK9 is constructed, a ship made of Pre-Gate materials and technology with the ability to absorb parasite energy and use it to power its incredible arsenal. Piloting the RSK9 is Alys, an ace pilot previously missing in action that has returned seemingly immune to parasite control. Her skill and resistance to the parasite energies influence make her the only pilot capable of preventing the extinction of mankind.</p>
				<h3>GAME PLAY:</h3>
				<ul>
					<li>-Increase your B-Meter &amp; firepower quickly by flying as close to enemy fire as possible and absorbing their energy. The closer you fly, the more energy you net!</li>
					<li>-Fire your weapon while flying close to enemy fire and absorbing to perform powerful "Risk Shots". Enemies destroyed by these powered up shots will turn into energy to power your shield. The best defense is a risky offense!</li>
					<li>-Fly like an ace pilot and utilize Barrel Rolls to quickly cover vertical space &amp; modify your attack!</li>
					<li>-Unleash the Barrier Breaker once the B-Meter is full to inflict huge damage on everything in sight!</li>
					<li>-Playing for points is fun again as higher scores are awarded for explosive bursts of destruction and taking risks! Destroy multiple enemies at once and utilize "Risk Shots" to string together combos and increase your score multiplier!</li>
					<li>-Experience different facets and paths to the story based on your performance and actions taken during missions!</li>
				</ul>
				<h3>Available May 14th, 2019</h3>
				<div>
					<h2>WISHLIST OR FOLLOW RISK SYSTEM NOW!</h2>
					<div style={{ textAlign: 'center' }}>
						<Button variant={'raised'} color={'secondary'} style={{ width: '200px', margin: '15px'}} >
							<a href={'https://risksystem.itch.io/rs'} target={'_blank'}><img src={itchIoLogo} /></a>
						</Button>
						<Button variant={'raised'} color={'secondary'} style={{ width: '200px', margin: '25px'}} >
							<a href={'https://store.steampowered.com/app/833950/Risk_System'} target={'_blank'} style={{height: '32px'}}><img src={steamLogo} /></a>
						</Button>
						<Button variant={'raised'} color={'secondary'} style={{ width: '200px', margin: '15px'}}>
							<a href={'https://www.humblebundle.com/store/risk-system'} target={'_blank'} style={{color: 'black', height: '32px', lineHeight: '32px', fontWeight: 'bold', fontSize: '16px'}}>Humble</a>
						</Button>
					</div>
				</div>
				<div style={{ margin: '10px auto', textAlign: 'center', fontSize: '11px' }}>Copyright (c) 2019 Newt Industries, LLC.  All rights reserved.</div>
			</div>
		);
	}

	private getGarbingeCopy() {
		return (
			<div style={{ color: '#FEFF20' }}>
				<p>GarBinge! is a high energy puzzle game where not everything is as it seems and quick wits can lead you to surprising solutions.</p>
				
				<p>You must sort the trash while contending with legions of hungry raccoons with one thing on their minds...eating garbage!</p>
				<ul>
					<li>NO in game purchases or micro-transactions, skill alone determines the leaderboards!</li>
					<li>Build up gigantic combos and score multipliers for quick strings of perfect garbage placement!</li>
					<li>Challenge yourself with infinitely escalating difficulty!</li>
					<li>Get achievements through meeting challenges during gameplay to unlock items in gallery mode!</li>
					<li>Bask in the lovingly crafted pixel art and animations!</li>
				</ul>
				<p>As an indie game studio, we at Newt Industries believe the mobile game market should be about giving players complete and satisfying experiences. 
					We don't call our games "free to play" and then hold content or the ability to keep playing at ransom. 
					We strive to make our games worth more than the price of admission and we give players access to our games in their entirety for that cost, including future expansions and updates. 
					Help us prove that quality can beat deceptive business practices and become the new standard for the industry.</p>
				<h2>Product features</h2>
				<ul>
					<li>Fast-paced arcade action.</li>
					<li>Unlock achievements and gallery items.</li>
					<li>Engaging pixel art in a classic style.</li>
					<li>Global leaderboards to conquer.</li>
					<li>Continuously updated gameplay stats.</li>
				</ul>
				<div>
					<h2>DOWNLOAD NOW</h2>
					<div style={{ textAlign: 'center', marginBottom: '25px' }}>
						<a style={{height: '64px'}} target={'_blank'} href={'https://play.google.com/store/apps/details?id=com.newtindustries.garbinge&hl=en_US&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'}><img style={{height: '64px'}} alt={'Get it on Google Play'} src={'https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'}/></a>
						<a style={{height: '64px'}} href={'https://www.amazon.com/gp/product/B019R0CA8I/ref=garbinge'} target={'_blank'}><img style={{height: '42px', margin: '10px'}} src={amazonLogo} /></a>
						<a style={{height: '64px'}} href={'https://itunes.apple.com/us/app/garbinge!/id1082362111?mt=8'} target={'_blank'}><img style={{height: '42px', margin: '10px'}} src={appleLogo} /></a>
					</div>
				</div>
			</div>
		);
	}
}

export default withTheme()(withStyles(styles)(Home));


// WEBPACK FOOTER //
// ./src/components/Home.tsx